import { useContext } from "react";

import { FormType } from "@simplyk/common";
import { useSearchParams } from "next/navigation";

import { IS_PREVIEW_QUERY_PARAM } from "../../../../common/constants/url";
import { FrontendFormContext } from "../../../../common/contexts/FrontendFormContext";
import { useIsIframe } from "../../../../common/hooks/useIsIframe";
import { useIsOnboarding } from "../../../../common/hooks/useIsOnboarding";
import { PageLoadingContext } from "../../../../common/providers/PageLoadingProvider";

interface ShouldDisplayPaymentNotReadyBannerProps {
  currentOrganization: { id: string } | undefined | null;
  form: { organization: { id: string } } | null | undefined;
}

export const useShouldDisplayPaymentNotReadyBanner = ({
  currentOrganization,
  form,
}: ShouldDisplayPaymentNotReadyBannerProps) => {
  const { formType, formData, isFreeTicketing, displayedFormAmount } = useContext(FrontendFormContext);
  const search = useSearchParams();
  const { isOnboarding } = useIsOnboarding();
  const isIframe = useIsIframe();
  const { isLoading } = useContext(PageLoadingContext);
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());

  const isPreviewTemplateMode = query.previewTemplateMode === "true";
  const isPreview = search.get(IS_PREVIEW_QUERY_PARAM) === "true" || false;

  const isOwner = currentOrganization?.id === form?.organization.id;

  const paymentFormTypes = [FormType.DonationForm, FormType.Ticketing];
  const isPaymentForm = formType && paymentFormTypes.includes(formType);

  const isFormPageDonorView = formData.id;

  const formOrg = formData.organization;

  const isPaymentReady = formOrg && formOrg.isStripeCustomAccountActive && !formOrg.isPaymentDisabled;

  return (
    !isOwner &&
    !isOnboarding &&
    !isPreviewTemplateMode &&
    !isPreview &&
    !isIframe &&
    isPaymentForm &&
    isFormPageDonorView &&
    !isPaymentReady &&
    !isLoading &&
    !isFreeTicketing &&
    displayedFormAmount > 0
  );
};
